import "./BrandedBasecamp.module.css";
import Header from "@/reusable_sections/Header";
import OurProcess from "./sections/OurProcess";
import SecureYourStay from "./sections/SecureYourStay";
import Footer from "@/reusable_sections/Footer";
export default function BrandedBasecampPage() {
  return <div>
      <Header />
      <OurProcess />
      <SecureYourStay />
      <Footer />
    </div>;
}